import React, { memo, useCallback } from 'react';
import { RadioButton } from '@yme/atoms/radio-button';
import { buildKey, noop } from '@yme/common/index';
import { SVGIcon } from '../svg-icon';
import { ButtonRectangleRadioStyled } from './styled';
function ButtonRectangleRadioComponent(props) {
    const { value, setIsActive, index, isSelected, tagContent, tagContentProps, isDisabled, dataTestId = 'atom', allowClickOnDisabled, isWidthFlexible, isRadioVisible, iconType, } = props;
    const onClickHandler = useCallback((event) => {
        event.stopPropagation();
        event.preventDefault();
        if (!isSelected) {
            setIsActive(index);
        }
    }, [index, isSelected, setIsActive]);
    if (!value) {
        return null;
    }
    const id = buildKey(value, index);
    const dataTestIdComponent = buildKey(dataTestId, 'button-rectangle-radio');
    return (React.createElement(ButtonRectangleRadioStyled, { isSelected: isSelected, isDisabled: isDisabled, onClick: onClickHandler, "data-testid": dataTestIdComponent, isWidthFlexible: isWidthFlexible, allowClickOnDisabled: allowClickOnDisabled, isRadioVisible: isRadioVisible },
        React.createElement(RadioButton, { id: id, name: id, value: value, isChecked: isSelected, onChange: noop }),
        React.createElement(tagContent, tagContentProps, value),
        iconType && React.createElement(SVGIcon, { type: iconType })));
}
export const ButtonRectangleRadio = memo(ButtonRectangleRadioComponent);
ButtonRectangleRadio.displayName = 'ButtonRectangleRadio_Atom';
